import axios from 'axios';
import qs from 'qs';
// 访问路径
import config from "./config"
// 接口api
import api from "./api"
// 引入 Vant
import { Toast } from 'vant';
// 状态管理
import store from '../store/index'

axios.defaults.timeout = 30000;
axios.defaults.baseURL = config.baseUrl;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;


//http request 拦截器
axios.interceptors.request.use(config => {
	// config.headers["memberId"] = store.getters.GET_LOGIN_ID == null ? '' : store.getters.GET_LOGIN_ID;
	if (store.getters.GET_TOKEN) {
		config.headers['Authorization'] = store.getters.GET_TOKEN;
	}
	config.headers['AppType'] = 'JT'
	// config.headers['Authorization'] = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxNDUyNTcyMzM1NTczNDMwMjczLCJ1c2VyX25hbWUiOiIxODc4MTk0ODM4NiIsInNjb3BlIjpbInNlcnZlciJdLCJleHAiOjE2Mzk1NTI2MTYsImF1dGhvcml0aWVzIjpbIkdVRVNUIl0sImp0aSI6ImE4NjNkMjJhLTg3ZDEtNDg3Yy1hMmVkLWVhZmI3ZGIzMjI4NyIsImNsaWVudF9pZCI6Im1iY2xvdWQiLCJ1c2VybmFtZSI6IjE4NzgxOTQ4Mzg2In0.mguIBeMM_YhEHT2QtIN3-oWb-diHXRbakgbJcl6Ozlw';
	if (config.method == "get") {
		if (config.url.indexOf('?') > -1) {
			config.url = config.url + "&timestamp=" + new Date().getTime();
		} else {
			config.url = config.url + "?timestamp=" + new Date().getTime();
		}
	}
	return config;
}, error => {
	return Promise.reject(error);
});

// http response 拦截器
axios.interceptors.response.use(response => {
	return response;
}, error => {
	if (error && error.response) {
		switch (error.response.status) {
			case 400: Toast('错误请求'); break;
			case 401: Toast('未授权，请重新登录'); break;
				// toLoginPage()
				break;
			case 403: Toast('拒绝访问'); break;
			case 404: Toast('请求错误,未找到该资源'); break;
			case 405: Toast('请求方法未允许'); break;
			case 408: Toast('请求超时'); break;
			case 500: Toast('服务器端出错'); break;
			case 501: Toast('网络未实现'); break;
			case 502: Toast('网络错误'); break;
			case 503: Toast('服务不可用'); break;
			case 504: Toast('网络超时'); break;
			case 505: Toast('http版本不支持该请求'); break;
			case 510: Toast('510错误'); break;
			default: Toast(error.response.msg);
		}
	} else {
		Toast('连接到服务器失败');
	}
	return Promise.reject(error);
});

// 封装get方法
function get(url, params = {}, callBack = undefined) {
	return new Promise((resolve, reject) => {
		axios.get(url, { params }).then(response => {
			const res = response.data;
			if (res && parseInt(res.code) == 0) {
				resolve(res.data);
			} else {
				if (res.msg) {
					Toast(res.msg);
				}
				if (callBack) {
					callBack(res)
				}
			}
		}).catch(err => {
			reject(err);
		});
	})
}	
// 封装post请求
function post(url, params = {}, callBack = undefined) {
	return new Promise((resolve, reject) => {
		axios.post(url, qs.stringify(params), config).then(response => {
			const res = response.data;
			if (res && parseInt(res.code) == 0) {
				resolve(res.data);
			} else {
				if (res.msg) {
					Toast(res.msg);
				}
				if (callBack) {
					callBack(res)
				}
			}
		}, err => {
			reject(err);
		})
	})
}
function toLoginPage() {
	if (deviceType() == "Android") {
		JSBridge.guitarAppListener(JSON.stringify({
			method: 'toLoginPage',
			params: {},
		}));
	} else if (deviceType() == "IOS") {
		window.webkit.messageHandlers.guitarAppListener.postMessage({
			method: 'toLoginPage',
			params,
		});
	}
}


// 判断设备类型
function deviceType() {
	var u = navigator.userAgent;
	var isIPhone = "Android";
	if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
		//安卓手机
		isIPhone = "Android";
	} else if (u.indexOf('iPhone') > -1) {
		//苹果手机
		isIPhone = "IOS";
	} else if (u.indexOf('Windows Phone') > -1) {
		//winphone手机
		isIPhone = "IOS";
	}
	return isIPhone;
}

export default {
	baseUrl: config.baseURL,
	imageUrl: config.imageUrl,
	getHelpType: data => {//获取帮助中心分类
		return get('/app/helptype/getAllHelp', data)
	},

	getHelpDetail: data => {//获取帮助中心详情
		return get('/app/help/getById', data)
	},
	getClassCourse: data => {//获取速成或者自学课
		return get('/app/course/getClassCourse', data)
	},

	getUserSelfStudyTime: data => {//获取用户剩余自学时间
		return get('/app/member/UserInfo', data)
	},
	getCourse: data => {//获取课程下的数据
		return get('/app/course/getCourse', data)
	},
	getCourseDetailList: data => {//获取课程目录(自学/速成)
		return get('/app/course/getCourseDetailList', data)
	},
	checkIsBuy: data => {//判断课程是否购买
		return get('/app/courseorder/checkBuyCourse', data)
	},
	getAlreadyBoughtCourse: data => {//获取速成课已购课程
		return get('/app/course/getAlreadyBoughtCourse', data)
	},
	getLastStudy: data => {//获取速成或自学的上次学习课节的ID
		return get('/app/studyrecord/getLastStudy', data)
	},
	getPrivacyPolicy: data => {//用户协议隐私政策
		return get('/app/setting/getPrivacyPolicy', data)
	},
	getCourseWork: data => {//作业区
		return get('/app/memberwork/getCourseWork', data)
	},
	getMemberWorkVO: data => {//作业详情及评论
		return get('/app/memberwork/getMemberWorkVO', data)
	},
	giveALike: data => {//点赞
		return get('/app/CourseDetailHistory/giveALike', data)
	},
	//发送评论
	sendComment: data => {
		console.log(data)
		return post('/app/workcomment/create', data)
	},
	//获取作业评论
	getWorkComment: data => {
		return get('/app/workcomment/getWorkComment', data)
	},
	//获取系统通知
	getSysNotice: data => {
		return get('/app/message/page', data)
	},
	//获取系统通知详情
	getSysNoticeDetail: data => {
		return get('/app/pushmessage/getPushMessageDetail', data)
	},
	//获取作业通知详情
	getSysWorkNotice: data => {
		return get('/app/pushmessage/getPushMessage', data)
	},
	//qq配置
	getQQSetting: data => {
		return get('/app/setting/getQQGroupConfiguration', data)
	},
	// 获取动态列表
	getList: data => {
		return get(`/app/community/getWorkList`, data)
	},
	// 获取作业详情
	getMenberDetail: data => {
		return get(`/app/memberwork/getWorkDetail`, data)
	},
	// 作业列表
	getWorkList: data => {
		return get(`/app/memberwork/getMyWorkInfo?size=1&current=999`)
	},
	// 获取用户信息
	getUserInfo: data => {
		return get(`/app/member/UserInfo`)
	},
	// 获取更多评论
	getMoreComment: data => {
		return get(`/app/memberwork/getCommentList`, data)
	},
	// 阅读消息
	getMessege: data => {
		return get(`/app/pushmessage/getReadMessage`, data)
	},



	deviceType: () => {//判断手机类型
		return deviceType();
	},
	guitarAppListener(funName, params) {//
		if (deviceType() == "Android") {
			JSBridge.guitarAppListener(JSON.stringify({
				method: funName,
				params,
			}));
		} else if (deviceType() == "IOS") {
			window.webkit.messageHandlers.guitarAppListener.postMessage({
				method: funName,
				params,
			});
		}
	},
	guitarBannerListener(funName, params) {
		if (deviceType() == "Android") {
			JSBridge.guitarAppListener(JSON.stringify({
				method: funName,
				params,
			}));
		} else if (deviceType() == "IOS") {
			window.webkit.messageHandlers.guitarAppListener.postMessage({
				method: funName,
				params,
			});
		}
	}
	//回到原生页面
	//  backToNative: () => {
	// 	if(deviceType() == "Android"){
	// 		JSBridge.backToNative();
	// 	}else if(deviceType() == "IOS"){
	// 		window.webkit.messageHandlers.backToNative.postMessage(null);
	// 	}
	// },
	// 跳转到原生登录页面







}